import type { TFunction } from 'i18next'

import { BasicCurrencyField, BasicTextField } from '@/entities/column'

import { createSRTColumnHelper } from '@/shared/components/master-table'

import {
	AddIdxCell,
	MulIdxCell,
	SkuCell,
	SourceFamilyIdCell,
} from '../ui/AnchorProductsTableCells'

const columnHelper = createSRTColumnHelper()
export const getColumns = (t: TFunction) => [
	columnHelper.accessor('sku', {
		id: 'sku',
		header: t('field_schema_sku'),
		size: 100,
		Cell: ({ cellValue }) => <SkuCell value={cellValue} />,
	}),
	columnHelper.accessor('title', {
		id: 'title',
		header: t('field_schema_product_name'),
		size: 200,
	}),
	columnHelper.accessor('sales_entity', {
		id: 'sales_entity',
		header: t('field_schema_pos_id'),
		size: 100,
		Cell: ({ cellValue }) => <BasicTextField value={cellValue?.name || '-'} />,
	}),
	columnHelper.accessor('cost', {
		id: 'cost',
		header: t('field_schema_cost'),
		size: 80,
		Cell: ({ cellValue }) => <BasicCurrencyField value={cellValue} />,
	}),
	columnHelper.accessor('last_price', {
		id: 'price',
		header: t('field_schema_last_price'),
		size: 80,
		Cell: ({ cellValue }) => <BasicCurrencyField value={cellValue} />,
	}),
	columnHelper.display({
		header: t('field_schema_family_id'),
		id: 'source_family_id',
		size: 100,
		Cell: () => <SourceFamilyIdCell />,
	}),
	columnHelper.display({
		header: t('mul_idx'),
		size: 100,
		Cell: ({ row }) => <MulIdxCell row={row} />,
	}),
	columnHelper.display({
		header: t('add_idx'),
		size: 100,
		Cell: ({ row }) => <AddIdxCell row={row} />,
	}),
]
